<template>
  <div>
    <section class="page-content">
      <form action @submit.prevent="next">
        <article class="d-flex flex-column justify-content-center form-heading title-section form-section">
          <h1 class="font-weight-bold text-center w-75 mb-0">APPLICATION</h1>
          <h2>Private Investigators Application</h2>
        </article>
        <article class="input-section form-section">
          <label for class="orep-label">
            <span class="mr-1">1.</span>Name:
          </label>
          <input
            type="text"
            name="nameOfApplicant"
            v-model="piApplication.nameOfApplicant"
            class="orep-text-input"
            v-validate="'required'"
            @input="validateBeforeSubmit()"
          >
          <span
            v-show="errors.has('nameOfApplicant')"
            class="help is-danger form-errors text-danger"
          >{{ errors.first('nameOfApplicant') | filterText }}</span>
        </article>
        <article class="form-section">
          <div class="input-section" >
            <div class="row pb-3">
              <div class="col-md-6">
                <label for class="orep-label mb-0 ml-1"><span class="mr-1">2.</span>
                  Address Street:
                </label>
                <input
                  type="text"
                  name="address"
                  v-model="piApplication.customer.address"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('address')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('address') | filterText }}</span>
              </div>
<!--              <div class="col-md-6">-->
<!--                <label for class="orep-label mb-0 ml-1">-->
<!--                  Address Street:-->
<!--                </label>-->
<!--                <input-->
<!--                  type="text"-->
<!--                  name="street"-->
<!--                  v-model="piApplication.street"-->
<!--                  class="orep-text-input w-100"-->
<!--                  v-validate="'required'"-->
<!--                  @input="validateBeforeSubmit()"-->
<!--                >-->
<!--                <span-->
<!--                  v-show="errors.has('street')"-->
<!--                  class="help is-danger form-errors text-danger"-->
<!--                >{{ errors.first('street') | filterText }}</span>-->
<!--              </div>-->
              <div class="col-md-6">
                <label for class="orep-label mb-0 ml-1">
                  City:
                </label>
                <input
                  type="text"
                  name="city"
                  v-model="piApplication.customer.city"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('city')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('city') | filterText }}</span>
              </div>
            </div>
            <div class="row pb-3">
              <div class="col-md-4">
                <label for class="orep-label mb-0 ml-1">
                  State:
                </label>
                <select
                  class="orep-select w-100"
                  style="height: 40px; width: 383px;"
                  name="state"
                  v-model="piApplication.customer.state"
                  v-validate="'required'"
                  @change="validateBeforeSubmit()"
                >
                  <option v-for="(item, key) in states" :value="key">
                    {{item}}
                  </option>
                </select>
                <span
                  v-show="errors.has('state')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('state') | filterText }}</span>
              </div>
              <div class="col-md-4">
                <label for class="orep-label mb-0 ml-1">
                  ZIP Code:
                </label>
                <input
                  type="text"
                  name="zipCode"
                  v-model="piApplication.customer.zipCode"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('zipCode')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('zipCode') | filterText }}</span>
              </div>
              <div class="col-md-4">
                <label for class="orep-label mb-0 ml-1">
                  County:
                </label>
                <input
                  type="text"
                  name="county"
                  v-model="piApplication.customer.county"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('county')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('county') | filterText }}</span>
              </div>
            </div>


          </div>

        </article>
        <article class="input-section form-section">
          <div class="row pb-3">
            <div class="col-md-4">
              <label for class="orep-label mb-0">
                <span class="qtn mrpx-5">3.</span>Contact:
              </label>
              <input
                type="text"
                name="contact"
                v-model="piApplication.contact"
                class="orep-text-input w-100"
                v-validate="'required'"
                @input="validateBeforeSubmit()"
              >
              <span
                v-show="errors.has('contact')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('contact') | filterText }}</span>
            </div>
            <div class="col-md-4">
              <label for class="orep-label mb-0">
                <span class="qtn mrpx-5"></span>Telephone:
              </label>
              <input
                type="text"
                name="phone"
                v-model="piApplication.customer.phone"
                v-validate="'required'"
                class="orep-text-input w-100"
              >
              <span
                v-show="errors.has('phone')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('phone') | filterText }}</span>
            </div>
            <div class="col-md-4">
              <label for class="orep-label mb-0">
                <span class="mr-1"></span>Fax:
              </label>
              <input
                type="fax"
                name="fax"
                autocomplete="Fax"
                v-model="piApplication.customer.fax"
                class="orep-text-input w-100"
                v-validate="'required'"
                @input="validateBeforeSubmit()"
              >
              <span
                v-show="errors.has('fax')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('fax') | filterText }}</span>
            </div>

          </div>
        </article>
        <article class="input-section form-section">
          <div class="row pb-3">
            <div class="col-md-4">
              <label for class="orep-label mb-0">
                <span class="mr-1">4.</span>Insured's Email Address:
              </label>
              <input
                type="email"
                name="email"
                autocomplete="email"
                v-model="piApplication.customer.email"
                class="orep-text-input w-100"
                v-validate="'required|email'"
                @input="validateBeforeSubmit()"
              >
              <span
                v-show="errors.has('email')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('email') | filterText }}</span>
            </div>

          </div>
        </article>
        <article class="input-section form-section">
          <label for class="orep-label">
            <span class="mr-1">5.</span>Total number of employees:
          </label>
            <div class="row" style="margin-right: 56px;">
              <div class="col-md-4">
                <label for class="orep-label mb-0">
                  Full Time
                </label>
                <input
                  type="text"
                  name="numberOfFullTimeEmployees"
                  v-model="piApplication.numberOfFullTimeEmployees"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('numberOfFullTimeEmployees')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('numberOfFullTimeEmployees') | filterText }}</span>
              </div>
              <div class="col-md-4">
                <label for class="orep-label mb-0">
                  Part Time
                </label>
                <input
                  type="text"
                  name="numberOfPartTimeEmployees"
                  v-model="piApplication.numberOfPartTimeEmployees"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('numberOfPartTimeEmployees')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('numberOfPartTimeEmployees') | filterText }}</span>
              </div>
            </div>
        </article>
        <article class="input-section form-section">
          <label for class="orep-label">
            <span class="mr-1">6.</span>Date established:
          </label>
          <input
            type="text"
            name="dateFirmEstablished"
            v-model="piApplication.dateFirmEstablished"
            class="orep-text-input"
            v-validate="'required'"
            @input="validateBeforeSubmit()"
          >
          <span
            v-show="errors.has('dateFirmEstablished')"
            class="help is-danger form-errors text-danger"
          >{{ errors.first('dateFirmEstablished') | filterText }}</span>
          <div style="margin-top: 30px;margin-bottom: 10px;">
            <label for class="orep-label">
              License No.:
            </label>

            <input
              type="text"
              name="licenseNumber"
              v-model="piApplication.licenseNumber"
              class="orep-text-input"
              v-validate="'required'"
              @input="validateBeforeSubmit()"
            >
            <span
              v-show="errors.has('licenseNumber')"
              class="help is-danger form-errors text-danger"
            >{{ errors.first('licenseNumber') | filterText }}</span>
          </div>
          <div class="row align-items-center mx-1 pb-0 pt-3">
            <label for class="orep-label mb-0">Applicant Ownership: </label>
            <div class="radio orep-radio-wrapper">
              <label>
                <input
                  type="radio"
                  name="applicantOwnership"
                  value="soleProprietor"
                  class="orep-radio"
                  @change="validateBeforeSubmit()"
                  v-model="piApplication.applicantOwnership"
                >
                <span class="radio-span">Sole Proprietor</span>
              </label>
            </div>
            <div class="radio orep-radio-wrapper">
              <label>
                <input
                  type="radio"
                  name="applicantOwnership"
                  value="partnership"
                  class="orep-radio"
                  @change="validateBeforeSubmit()"
                  v-model="piApplication.applicantOwnership"
                >
                <span class="radio-span">Partnership</span>
              </label>
            </div>
            <div class="radio orep-radio-wrapper">
              <label>
                <input
                  type="radio"
                  name="applicantOwnership"
                  value="corporation"
                  class="orep-radio"
                  v-validate="'required|included:soleProprietor,partnership,corporation,other'"
                  @change="validateBeforeSubmit()"
                  v-model="piApplication.applicantOwnership"
                >
                <span class="radio-span">Corporation</span>
              </label>
            </div>
            <div class="radio orep-radio-wrapper">
              <label>
                <input
                  type="radio"
                  name="applicantOwnership"
                  value="other"
                  class="orep-radio"
                  @change="validateBeforeSubmit()"
                  v-model="piApplication.applicantOwnership"
                >
                <span class="radio-span">Other</span>
              </label>
            </div>


          </div>
          <span
            v-show="errors.has('applicantOwnership')"
            class="help is-danger form-errors text-danger mt-0 mb-2"
          >{{ errors.first('applicantOwnership') | filterText }}</span>
        </article>
        <article class="input-section form-section">
          <label for class="orep-label">
            <span class="mr-1">7. </span>Policy proposed effective date:
          </label>
          <div class="row">
            <div class="col-md-4">
              <label for class="orep-label mb-0 ml-1">
                From:
              </label>
              <datepicker
                name="effectiveDateFrom"
                v-model="piApplication.effectiveDateFrom"
                v-validate="'required'"
                format="MM/dd/yyyy"
                input-class="orep-text-input w-75"
                @input="validateBeforeSubmit()"
                :disabled="state.effectiveDateFromValid"
                :clearButton="false"
                :value="computedDates"
              ></datepicker>
              <span
                v-show="errors.has('effectiveDateFrom')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('effectiveDateFrom') | filterText }}</span>
            </div>
            <div class="col-md-4">
              <label for class="orep-label mb-0 ml-1">
                To:
              </label>
              <datepicker
                name="effectiveDateTo"
                v-model="piApplication.effectiveDateTo"
                v-validate="'required'"
                format="MM/dd/yyyy"
                input-class="orep-text-input w-75"
                :disabled="state.effectiveDateToValid"
                @input="validateBeforeSubmit()"
                :clearButton="false"
                :value="computedDates"
              ></datepicker>
              <span
                v-show="errors.has('effectiveDateTo')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('effectiveDateTo') | filterText }}</span>
            </div>
          </div>
        </article>
        <article class="input-section form-section">
          <h4 class="inputs-table-title">
            <span class="qtn mrpx-5">8.</span>Please fill out the table below for the current and previous policy year:
          </h4>
          <div class="table-responsive hc-table inputs-table hc-small-table">
            <table class="table">
              <thead>
              <tr>
                <th class="th-left"></th>
                <th></th>
                <th>Current Policy Year (next 12 months)</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td class="td-res">Annual Revenue (sales)</td>
                <td></td>
                <td> $
                  <input
                    type="number"
                    oninput="this.value=(parseInt(this.value)||0)"
                    class="orep-text-input table-text-input"
                    name="annualRevenueSales"
                    v-validate="'required|numeric'"
                    @input="validateBeforeSubmit()"
                    v-model="piApplication.annualRevenueSales"
                  >
                  <span
                    v-show="errors.has('annualRevenueSales')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('annualRevenueSales') | filterText }}</span>
                </td>
                <td></td>
              </tr>
              <tr>
                <td class="td-res">Annual Payroll*</td>
                <td></td>
                <td>
                  $
                  <input
                    type="number"
                    oninput="this.value=(parseInt(this.value)||0)"
                    class="orep-text-input table-text-input"
                    name="annualPayroll"
                    v-validate="'required|numeric'"
                    @input="validateBeforeSubmit()"
                    v-model="piApplication.annualPayroll"
                  >
                  <span
                    v-show="errors.has('annualPayroll')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('annualPayroll') | filterText }}</span>
                </td>
                <td></td>
              </tr>
              <tr>
                <td class="td-res">Amount Paid to Subs</td>
                <td></td>
                <td>$

                  <input
                    type="number"
                    oninput="this.value=(parseInt(this.value)||0)"
                    class="orep-text-input table-text-input"
                    name="amountPaid"
                    v-validate="'required|numeric'"
                    @input="validateBeforeSubmit()"
                    v-model="piApplication.amountPaid"
                  >
                  <span
                    v-show="errors.has('amountPaid')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('amountPaid') | filterText }}</span>
                </td>
                <td></td>
              </tr>
              </tbody>
            </table>
            <p class="more-desc-p table-p flex contractors-p pt-25">
              <i class="table-info-fa legalese-fa fas fa-info-circle"></i>
              <span>*Employees/owners who perform private investigation services. Do not include clerical or sales payroll.</span>
            </p>
          </div>
        </article>
        <article class="input-section form-section">
          <label for class="orep-label">
            <span class="qtn mrpx-5">9.</span>Services Provided: Please check services that you now provide or would provide if requested.
          </label>
          <div class="row">
            <div class="col-md-3">
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="deductible"
                    value
                    class="orep-radio position-relative"
                    v-model="piApplication.narcoticsSurveillance"
                  >
                  <span class="radio-span solo-checkbox-span no-top">Narcotics Surveillance</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="deductible"
                    value
                    class="orep-radio position-relative"
                    v-model="piApplication.autoRepossession"
                  >
                  <span class="radio-span solo-checkbox-span no-top">Auto Repossession</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="deductible"
                    value
                    class="orep-radio position-relative"
                    v-model="piApplication.bodyguardProtection"
                  >
                  <span class="radio-span solo-checkbox-span no-top">Bodyguard/Exec. Protection</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="deductible"
                    value
                    class="orep-radio position-relative"
                    v-model="piApplication.storeDetective"
                  >
                  <span class="radio-span solo-checkbox-span no-top">Store Detective (Arrests)</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="deductible"
                    value
                    class="orep-radio position-relative"
                    v-model="piApplication.polygraphExam"
                  >
                  <span
                    class="radio-span solo-checkbox-span no-top"
                  >Polygraph/PSE Exam</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="deductible"
                    value
                    class="orep-radio position-relative"
                    v-model="piApplication.foreclosureSales"
                  >
                  <span class="radio-span solo-checkbox-span no-top">Foreclosure Sales</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="deductible"
                    value
                    class="orep-radio position-relative"
                    v-model="piApplication.bankAccountSearches"
                  >
                  <span class="radio-span solo-checkbox-span no-top">Bank Account Searches</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="deductible"
                    value
                    class="orep-radio position-relative"
                    v-model="piApplication.assetSearches"
                  >
                  <span class="radio-span solo-checkbox-span no-top">Asset Searches</span>
                </label>
              </div>
            </div>
            <div class="col-md-3">
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="deductible"
                    value
                    class="orep-radio position-relative"
                    v-model="piApplication.onlineSearches"
                  >
                  <span
                    class="radio-span solo-checkbox-span no-top"
                  >Online Searches</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="deductible"
                    value
                    class="orep-radio position-relative"
                    v-model="piApplication.accidentReconstruction"
                  >
                  <span class="radio-span solo-checkbox-span no-top">Accident Reconstruction</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="deductible"
                    value
                    class="orep-radio position-relative"
                    v-model="piApplication.arsonInspections"
                  >
                  <span class="radio-span solo-checkbox-span no-top">Arson Investigations (C&O)</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="deductible"
                    value
                    class="orep-radio position-relative"
                    v-model="piApplication.attorneyInvestigations"
                  >
                  <span class="radio-span solo-checkbox-span no-top">Attorney/Legal Investigations</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="deductible"
                    value
                    class="orep-radio position-relative"
                    v-model="piApplication.fraudInvestigations"
                  >
                  <span class="radio-span solo-checkbox-span no-top">Insurance Fraud Investigations</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="deductible"
                    value
                    class="orep-radio position-relative"
                    v-model="piApplication.locateWitnesses"
                  >
                  <span
                    class="radio-span solo-checkbox-span no-top"
                  >Locate People/Witnesses</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="deductible"
                    value
                    class="orep-radio position-relative"
                    v-model="piApplication.domesticSurveillance"
                  >
                  <span class="radio-span solo-checkbox-span no-top">Domestic Surveillance</span>
                </label>
              </div>
              <!--                  <div class="radio orep-radio-wrapper solo-checkbox">-->
              <!--                    <label class="d-flex align-items-center">-->
              <!--                      <input-->
              <!--                        type="checkbox"-->
              <!--                        name="deductible"-->
              <!--                        value-->
              <!--                        class="orep-radio position-relative"-->
              <!--                        v-model="piApplication.cyberProtection"-->
              <!--                      >-->
              <!--                      <span-->
              <!--                        class="radio-span solo-checkbox-span no-top"-->
              <!--                      >Cyber Protection: I would like information on Cyber Coverage ($89 for $100,000 limits; $59 for $50,000 limits)</span>-->
              <!--                    </label>-->
              <!--                  </div>-->
            </div>
            <div class="col-md-3">
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="deductible"
                    value
                    class="orep-radio position-relative"
                    v-model="piApplication.undercoverOperatives"
                  >
                  <span class="radio-span solo-checkbox-span no-top">Undercover Operatives</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="deductible"
                    value
                    class="orep-radio position-relative"
                    v-model="piApplication.guardService"
                  >
                  <span class="radio-span solo-checkbox-span no-top">Guard Service/Property Protection</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="deductible"
                    value
                    class="orep-radio position-relative"
                    v-model="piApplication.processService"
                  >
                  <span class="radio-span solo-checkbox-span no-top">Process Service</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="deductible"
                    value
                    class="orep-radio position-relative"
                    v-model="piApplication.subpoenaService"
                  >
                  <span class="radio-span solo-checkbox-span no-top">Subpoena Service</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="deductible"
                    value
                    class="orep-radio position-relative"
                    v-model="piApplication.preemploymentBackgrounds"
                  >
                  <span class="radio-span solo-checkbox-span no-top">Pre-employment Backgrounds</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="deductible"
                    value
                    class="orep-radio position-relative"
                    v-model="piApplication.electronicCountermeasures"
                  >
                  <span class="radio-span solo-checkbox-span no-top">Electronic Countermeasures</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="deductible"
                    value
                    class="orep-radio position-relative"
                    v-model="piApplication.otherDescribe"
                  >
                  <span class="radio-span solo-checkbox-span no-top">Other (Describe)</span>
                </label>
              </div>
            </div>
          </div>
        </article>

        <article class="input-section form-section">
          <div class="flex flex-row">
            <div class="col-md-9">
              <label for class="orep-label">
                <span class="qtn mrpx-5">10.</span>Do you or any of your employees carry a firearm?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="employeesCarryFirearm"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="piApplication.employeesCarryFirearm"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="employeesCarryFirearm"
                      value="false"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="piApplication.employeesCarryFirearm"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                v-show="errors.has('employeesCarryFirearm')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('employeesCarryFirearm') | filterText }}</span>
            </div>
          </div>
          <div
            class="flex"
            v-if="piApplication.employeesCarryFirearm === 'true' || piApplication.employeesCarryFirearm == true"
          >
            <div class="col-md-9">
              <p>
                <span class="not-eligible-text">
                      <span class="qtn mrpx-5"></span>If yes, are they licensed?
                    </span>
              </p>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="employeesCarryFirearmLisensed"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="piApplication.employeesCarryFirearmLisensed"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="employeesCarryFirearmLisensed"
                      value="false"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="piApplication.employeesCarryFirearmLisensed"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                v-show="errors.has('employeesCarryFirearmLisensed')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('employeesCarryFirearmLisensed') | filterText }}</span>
            </div>
          </div>

        </article>
        <article class="input-section form-section">
          <label for class="orep-label">
            <span class="qtn mrpx-5">10.</span>Additional Coverages – Check all that apply
          </label>
          <label for class="orep-label">
            Additional Insureds
          </label>
          <div class="row">
            <div class="col-md-6">
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="additionalInsureds"
                    value
                    class="orep-radio position-relative"
                    v-model="piApplication.additionalInsuredsIndividual"
                  >
                  <span class="radio-span solo-checkbox-span no-top">Individual</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="additionalInsureds"
                    value
                    class="orep-radio position-relative"
                    v-model="piApplication.additionalInsuredsBlanket"
                  >
                  <span class="radio-span solo-checkbox-span no-top">Blanket</span>
                </label>
              </div>
            </div>
            <div class="col-md-6">
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="additionalInsureds"
                    value
                    class="orep-radio position-relative"
                    v-model="piApplication.additionalInsuredsPerProjectAggregate"
                  >
                  <span class="radio-span solo-checkbox-span no-top">Per Project Aggregate</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="additionalInsureds"
                    value
                    class="orep-radio position-relative"
                    v-model="piApplication.additionalInsuredsStopGap"
                  >
                  <span class="radio-span solo-checkbox-span no-top">Stop Gap</span>
                </label>
              </div>
              <!--                  <div class="radio orep-radio-wrapper solo-checkbox">-->
              <!--                    <label class="d-flex align-items-center">-->
              <!--                      <input-->
              <!--                        type="checkbox"-->
              <!--                        name="deductible"-->
              <!--                        value-->
              <!--                        class="orep-radio position-relative"-->
              <!--                        v-model="piApplication.cyberProtection"-->
              <!--                      >-->
              <!--                      <span-->
              <!--                        class="radio-span solo-checkbox-span no-top"-->
              <!--                      >Cyber Protection: I would like information on Cyber Coverage ($89 for $100,000 limits; $59 for $50,000 limits)</span>-->
              <!--                    </label>-->
              <!--                  </div>-->
            </div>
          </div>
          <label for class="orep-label">
            Waiver of Subrogation
          </label>
          <div class="row">
            <div class="col-md-6">
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="waiverSubrogation"
                    value
                    class="orep-radio position-relative"
                    v-model="piApplication.waiverSubrogationIndividual"
                  >
                  <span class="radio-span solo-checkbox-span no-top">Individual</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="waiverSubrogation"
                    value
                    class="orep-radio position-relative"
                    v-model="piApplication.waiverSubrogationBlanket"
                  >
                  <span class="radio-span solo-checkbox-span no-top">Blanket</span>
                </label>
              </div>
            </div>
            <div class="col-md-6">
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="waiverSubrogation"
                    value
                    class="orep-radio position-relative"
                    v-model="piApplication.waiverSubrogationPerProjectAggregate"
                  >
                  <span class="radio-span solo-checkbox-span no-top">Per Project Aggregate</span>
                </label>
              </div>
              <!--                  <div class="radio orep-radio-wrapper solo-checkbox">-->
              <!--                    <label class="d-flex align-items-center">-->
              <!--                      <input-->
              <!--                        type="checkbox"-->
              <!--                        name="deductible"-->
              <!--                        value-->
              <!--                        class="orep-radio position-relative"-->
              <!--                        v-model="piApplication.cyberProtection"-->
              <!--                      >-->
              <!--                      <span-->
              <!--                        class="radio-span solo-checkbox-span no-top"-->
              <!--                      >Cyber Protection: I would like information on Cyber Coverage ($89 for $100,000 limits; $59 for $50,000 limits)</span>-->
              <!--                    </label>-->
              <!--                  </div>-->
            </div>
          </div>
          <label for class="orep-label">
            Primary Wording
          </label>
          <div class="row">
            <div class="col-md-6">
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="primaryWording"
                    value
                    class="orep-radio position-relative"
                    v-model="piApplication.primaryWordingIndividual"
                  >
                  <span class="radio-span solo-checkbox-span no-top">Individual</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="primaryWording"
                    value
                    class="orep-radio position-relative"
                    v-model="piApplication.primaryWordingBlanket"
                  >
                  <span class="radio-span solo-checkbox-span no-top">Blanket</span>
                </label>
              </div>
            </div>
            <div class="col-md-6">
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="primaryWording"
                    value
                    class="orep-radio position-relative"
                    v-model="piApplication.primaryWordingPerProjectAggregate"
                  >
                  <span class="radio-span solo-checkbox-span no-top">Per Project Aggregate</span>
                </label>
              </div>
            </div>
          </div>
        </article>
        <article class="input-section form-section" style="padding-right: 50px;">
          <div class="row">
            <p class="mt-4 mb-0 mx-5" align="justify">NOTICE TO APPLICANTS: THIS APPLICATION MUST BE COMPLETED IN FULL AS THE QUOTE WILL BE BASED SOLELY ON THE INFORMATION PROVIDED, ANY PERSON WHO KNOWINGLY AND WITH INTENT TO DEFRAUD ANY INSURANCE COMPANY OR OTHER PERSON, FILES AN APPLICATION FOR INSURANCE CONTAINING FALSE INFORMATION, OR CONCEALS FOR THE PURPOSE OF MISLEADING INFORMATION CONCERNING ANY FACT MATERIAL THERETO, COMMITS A FRAUDULENT INSURANCE ACT, WHICH IS A CRIME BY SIGNING THIS APPLICATION, THE SIGNOR WARRANTS THAT TO THEIR BEST KNOWLEDGE ALL INFORMATION GIVEN IS TRUE AND ACCURATE
            </p>
            <div class="col-md-6">
              <section class="notice-form mt-3">
                <p class="notice-form-date">Please print your name:</p>
                <input
                  type="text"
                  class="orep-text-input notice-input"
                  placeholder="Type Your Name"
                  name="noticeApplicantName"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                  v-model="piApplication.noticeApplicantName"
                >
                <span
                  v-show="errors.has('noticeApplicantName')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('noticeApplicantName') | filterText }}</span>
              </section>
            </div>
            <div class="col-md-6">
              <section class="notice-form mt-3">
                <p class="notice-form-date">Signature:</p>
                <input
                  type="text"
                  class="orep-text-input notice-input"
                  placeholder="Type Your Name to Sign"
                  name="noticeApplicantSignature"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                  v-model="piApplication.noticeApplicantSignature"
                >
                <span
                  v-show="errors.has('noticeApplicantSignature')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('noticeApplicantSignature') | filterText }}</span>
              </section>
            </div>
            <div class="col-md-6">
              <section class="notice-form mt-3">
                <p class="notice-form-date">Date:</p>
                <input
                  type="date"
                  class="orep-text-input notice-input text-center"
                  :value="formattedCurrentDate()"
                  disabled
                >
              </section>
            </div>
          </div>
        </article>
        <article class="input-section form-section" style="padding-right: 50px;">
          <div class="row">
            <p class="mt-4 mb-0 mx-5"><u>NOTICE TO PRODUCERS:</u> THE PRODUCER HEREBY WARRANTS THAT THE INFORMATION CONTAINED IN THIS APPLICATION IS TRUE AND CORRECT TO THE BEST OF THEIR KNOWLEDGE.
            </p>
<!--            <div class="col-md-6">-->
<!--              <section class="notice-form mt-3">-->
<!--                <p class="notice-form-date">Please print your name:</p>-->
<!--                <input-->
<!--                  type="text"-->
<!--                  class="orep-text-input notice-input"-->
<!--                  placeholder="Type Your Name"-->
<!--                  name="noticeProducerName"-->
<!--                  v-validate="'required'"-->
<!--                  @input="validateBeforeSubmit()"-->
<!--                  v-model="piApplication.noticeProducerName"-->
<!--                >-->
<!--                <span-->
<!--                  v-show="errors.has('noticeProducerName')"-->
<!--                  class="help is-danger form-errors text-danger"-->
<!--                >{{ errors.first('noticeProducerName') | filterText }}</span>-->
<!--              </section>-->
<!--            </div>-->

<!--            <div class="col-md-6">-->
<!--              <section class="notice-form mt-3">-->
<!--                <p class="notice-form-date">Signature:</p>-->
<!--                <input-->
<!--                  type="text"-->
<!--                  class="orep-text-input notice-input"-->
<!--                  placeholder="Type Your Name to Sign"-->
<!--                  name="noticeProducerSignature"-->
<!--                  v-validate="'required'"-->
<!--                  @input="validateBeforeSubmit()"-->
<!--                  v-model="piApplication.noticeProducerSignature"-->
<!--                >-->
<!--                <span-->
<!--                  v-show="errors.has('noticeProducerSignature')"-->
<!--                  class="help is-danger form-errors text-danger"-->
<!--                >{{ errors.first('noticeProducerSignature') | filterText }}</span>-->
<!--              </section>-->
<!--            </div>-->
            <div class="col-md-6">
              <section class="notice-form mt-3">
                <p class="notice-form-date">Date:</p>
                <input
                  type="date"
                  class="orep-text-input notice-input text-center"
                  :value="formattedCurrentDate()"
                  disabled
                >
              </section>
            </div>
<!--            <div class="col-md-6">-->
<!--              <section class="notice-form mt-3">-->
<!--                <p class="notice-form-date">License #:</p>-->
<!--                <input-->
<!--                  type="text"-->
<!--                  class="orep-text-input notice-input"-->
<!--                  placeholder="Type License #"-->
<!--                  name="noticeProducerLicense"-->
<!--                  v-validate="'required'"-->
<!--                  @input="validateBeforeSubmit()"-->
<!--                  v-model="piApplication.noticeProducerLicense"-->
<!--                >-->
<!--                <span-->
<!--                  v-show="errors.has('noticeProducerLicense')"-->
<!--                  class="help is-danger form-errors text-danger"-->
<!--                >{{ errors.first('noticeProducerLicense') | filterText }}</span>-->
<!--              </section>-->
<!--            </div>-->
          </div>
        </article>

      </form>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <article class="orep-pagination">
              <span class="pagination-dots pagination-current"></span>
              <button class="pagination-dots" :disabled="!state.pageOneIsValid" @click="next('pi-application-2')" ></button>
              <button class="pagination-dots" :disabled="!state.pageTwoIsValid" @click="next('pi-application-representation')" ></button>

            </article>
            <button type="submit" :disabled="!state.pageOneIsValid"
              :class="{submitDisabled: !state.pageOneIsValid}" class="next-btn mont spaced pull-right" @click="pageOneSubmit('pi-application-page-2')">Next</button>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import {APP_STATUS, STATES} from "../../utils/constants";
import Datepicker from 'vuejs-datepicker';
import moment from "moment";

export default {
  name: "pi-application-1",
  computedDates () {
    return moment(this.value).format('YYYY-MM-D')
  },
  data() {
    return {
      states: STATES
    };
  },
  computed: {
    piApplication() {
      return this.$store.state.piApplication.piApplication;
    },
    state() {
      return this.$store.state.piApplication;
    },
    errorMsg() {
      return this.$store.state.piApplication.errorMsg;
    },
    getApplicantType() {
      var route = this.$route.path;
      var first = route.substring(0, route.lastIndexOf("/") + 1);
      if (first === '/portal/pi-application-amba' || first === '/portal/pi-application-amba/' || this.piApplication.customer.partnerName === 'Mercer'){
        return 'Mercer';
      }else if (first === '/portal/pi-application-realshield' || first === '/portal/pi-application-realshield/' || this.piApplication.customer.partnerName === 'Realshield'){
        return 'Realshield';
      }else {
        return 'OREP';
      }
    },
  },

  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: this.errorMsg
          });
        }
      }
    }
  },

  methods: {
    navigateToNext(routeName) {
      this.$router.push({
        name: routeName
      });
    },
    formattedCurrentDate() {
      return moment(this.piApplication.appraiserEsignatureDatetime).format('YYYY-MM-DD');
    },
    pageOneSubmit(routeName) {
      this.loading = true;
      this.piApplication.customer.contactName = this.state.piApplication.nameOfPrimaryLicensed;
      this.piApplication.customer.companyName = this.state.piApplication.nameOfApplicant;
      this.piApplication.customer.isPiApplication = 'True';
      this.piApplication.customer.appStatus = APP_STATUS.Partially_Completed;
      if (this.getApplicantType === 'Mercer'){
        this.piApplication.customer.partnerName = 'Mercer';
      }
      else if (this.getApplicantType === 'Realshield'){
        this.piApplication.customer.partnerName = 'Realshield';
      }
      this.$store.dispatch('piApplication/createCustomer');

      // this.$router.push({
      //   name: routeName,
      // });
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageOneIsValid = true;
          return;
        }
        this.state.pageOneIsValid = false;
      });
    },
    validateBeforeSubmitCheck(e){
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageOneIsValid = true;
          return;
        }
        this.state.pageOneIsValid = false;
      });
    }
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },

  mounted() {
    const params = this.$route.query;
    if (params && params.filter) {
      this.state.piApplication.applicantRequestFrom = params.filter;
    }
    $('html, body').animate({
        scrollTop: $('.page-content').offset().top
    }, 500);
  },
  components: {
    Datepicker
  }
};
</script>

<style scoped>

</style>
